import { render, staticRenderFns } from "./finishedDetails.vue?vue&type=template&id=f9a38a6a&scoped=true"
import script from "./finishedDetails.vue?vue&type=script&lang=js"
export * from "./finishedDetails.vue?vue&type=script&lang=js"
import style0 from "./finishedDetails.vue?vue&type=style&index=0&id=f9a38a6a&prod&lang=scss"
import style1 from "./finishedDetails.vue?vue&type=style&index=1&id=f9a38a6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a38a6a",
  null
  
)

export default component.exports